import axiosInstance from 'api/axios';
import { APIResponse } from '../types';

export interface BlogResponse {
  id: number;
  title: string;
  context: string;
  file_name: string;
  folder_id: string;
  images_urls: string;
  blog: {
    no_of_images: number;
    industry: string;
    tone: string;
    language: string;
    max_len: string;
    min_len: string;
    topic: any;
    context: string;
  };
}

export interface GenerateBlogRequest {
  topic: string;
  language: string;
  img_number: number;
  tone: string;
  industry: string;
  min_len: number;
  max_len: number;
}

export interface allBlogResponse {
  id: number;
  title: string;
  file_name: string;
  topic: string;
  status: string;
  scheduled_at?: string;
  folder_id: number;
  created_at: string;
  cover_img_url: string;
}

export interface BlogHistoryResponse {
  id: number;
  blog_id: number;
  user_id: string;
  version: number;
  updated_content: string;
  created_at: string;
  blog: BlogResponse | null;
  user: null;
}
export interface BlogHistoryResponseById {
  id: number;
  blog_id: number;
  user_id: string;
  version: number;
  updated_content: string;
  created_at: string;
  blog: BlogResponse | null;
  user: null;
}
export const blogService = {
  // Generate Blog
  generateBlog: async (
    params: GenerateBlogRequest
  ): Promise<APIResponse<BlogResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/blogs/generate',
      params
    );
    return response.data;
  },

  // Get All Blogs
  getAllBlogs: async (): Promise<APIResponse<allBlogResponse[]>> => {
    const response = await axiosInstance.private.get('/api/v1/blogs/list/all');
    return response.data;
  },

  // Save Blog
  saveBlog: async (blogData: {
    title: string;
    context: string;
    file_name: string;
    folder_id: number | null;
    images_urls: string;
    topic: string;
    min_len: string;
    max_len: string;
    language: string;
    tone: string;
    industry: string;
    no_of_images: string;
  }): Promise<APIResponse<{ blog_id: number }>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/blogs/save',
      blogData
    );
    return response.data;
  },

  // Delete Blog
  deleteBlog: async (blogId: number): Promise<APIResponse<number>> => {
    const response = await axiosInstance.private.delete(
      `/api/v1/blogs/${blogId}`
    );
    return response.data;
  },

  // Get Blog by ID
  getBlog: async (blogId: number): Promise<APIResponse<BlogResponse>> => {
    const response = await axiosInstance.private.get(
      `/api/v1/blogs/my/${blogId}`
    );
    return response.data;
  },

  // Convert to Plain Text
  convertToPlain: async (data: {
    context: string;
  }): Promise<APIResponse<{ plain_text: string }>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/blogs/convert/plain',
      data
    );
    return response.data;
  },

  getBlogHistory: async (
    blogId: number
  ): Promise<APIResponse<BlogHistoryResponse[]>> => {
    const response = await axiosInstance.private.get(
      `/api/v1/blogs/${blogId}/history`
    );
    return response.data;
  },

  getBlogHistoryById: async (
    blogId: number,
    historyId: number
  ): Promise<APIResponse<BlogHistoryResponseById>> => {
    const response = await axiosInstance.private.get(
      `/api/v1/blogs/${blogId}/history/${historyId}`
    );
    return response.data;
  },

  // Get Shared Blogs
  getSharedBlogs: async (): Promise<APIResponse<BlogResponse[]>> => {
    const response = await axiosInstance.private.get('/api/v1/blogs/shared/me');
    return response.data;
  },

  // Update Blog
  updateBlog: async (
    blogId: number,
    updateData: { context?: string; title?: string; file_name?: string }
  ): Promise<APIResponse<BlogResponse>> => {
    const response = await axiosInstance.private.put(
      `/api/v1/blogs/${blogId}`,
      updateData
    );
    return response.data;
  },
};

export default blogService;
